export enum SportStatisticsTypeEnum {
	LiveStatisticsVisit = "live-statistics-click",
	BettingTypeStatistics = "betting-type-statistics-click",
	TeamLineupsVisit = "team-lineups-click",
}
